// extracted by mini-css-extract-plugin
export default {"mainContainer":"NumberCard_mainContainer__74Q3Y","numberContainer":"NumberCard_numberContainer__9KTjy","labelContainer":"NumberCard_labelContainer__QOzyq"};